import React from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'

type SideMenuItemProps = {
  icon: React.ReactElement
  name: string
  href: string
  className?: string
}

export function SideMenuItem({ icon, name, href, className, ...rest }: SideMenuItemProps) {
  const { t } = useTranslation()

  return (
    <Link
      href={href}
      className={twMerge('flex items-center text-text-primary', className)}
      {...rest}
    >
      <div className="mr-3 flex w-6 justify-center">{icon}</div>
      {t(name)}
    </Link>
  )
}
